import type { ExcelDownloadClient } from "app/components/React/ExcelButton/ExcelClientDownload";
import type {
    ContactsExportRequestDto,
    RevealedContactsResponseDto,
    TopNRevealRequestDto,
} from "app/pages/sales-intelligence/sub-modules/contacts-search/types/dto";
import type { CrmListObjectType, Integration } from "app/pages/sales-intelligence/sub-modules/management/types";
import type { IFetchService } from "app/services/fetchService";

import { extractCrmAndObjectType } from "../../helpers/crmList";
import type { CrmOpportunityListId } from "../../types";

function createCrmListWebsitesApiService(fetchService: IFetchService, excelDownloadClient: ExcelDownloadClient) {
    const createCrmListUrl = (crm: Integration, objectType: CrmListObjectType): string =>
        `/sales-api/${crm}/lists/${objectType}`;

    return {
        exportCrmListContactsToExcel(crm: Integration, objectType: CrmListObjectType, dto: ContactsExportRequestDto) {
            return excelDownloadClient(`${createCrmListUrl(crm, objectType)}/contacts/excel`, dto);
        },
        revealTopNContactsFromCrmList(
            id: CrmOpportunityListId,
            dto: TopNRevealRequestDto,
        ): Promise<RevealedContactsResponseDto> {
            const { crm, objectType } = extractCrmAndObjectType(id);
            return fetchService.post(`${createCrmListUrl(crm, objectType)}/contacts/reveal`, dto);
        },
    };
}

function createCrmListCompaniesApiService(fetchService: IFetchService, excelDownloadClient: ExcelDownloadClient) {
    const createCrmListUrl = (crm: Integration, objectType: CrmListObjectType): string =>
        `/sales-api/${crm}/lists/companies/${objectType}`;

    return {
        exportCrmListContactsToExcel(crm: Integration, objectType: CrmListObjectType, dto: ContactsExportRequestDto) {
            return excelDownloadClient(`${createCrmListUrl(crm, objectType)}/contacts/excel`, dto);
        },
        revealTopNContactsFromCrmList(
            id: CrmOpportunityListId,
            dto: TopNRevealRequestDto,
        ): Promise<RevealedContactsResponseDto> {
            const { crm, objectType } = extractCrmAndObjectType(id);
            return fetchService.post(`${createCrmListUrl(crm, objectType)}/contacts/reveal`, dto);
        },
    };
}

export default function createCrmListApiService(fetchService: IFetchService, excelDownloadClient: ExcelDownloadClient) {
    return {
        companies: createCrmListCompaniesApiService(fetchService, excelDownloadClient),
        websites: createCrmListWebsitesApiService(fetchService, excelDownloadClient),
    };
}
